import styles from "./HomePage.module.scss";

import { MouseEvent, useEffect, useRef, useState } from "react";

import Button from "./Button/StartButton";
import FloatingButton from "../Shared/FloatingButton/FloatingButton";
import { GlobalState } from "../../redux/store";
import { Link } from "react-router-dom";
import { strings } from "../../util/language";
import { useSelector } from "react-redux";
import { FiSettings } from "react-icons/fi";

const IMAGE = "/images/memory5.png";

const HomePage = () => {
  const { language } = useSelector((state: GlobalState) => state.settings);

  const style = {
    backgroundImage: `url(${IMAGE})`,
    backgroundSize: "cover",
  };

  return (
    <div style={style} className={styles.homePage}>
      <div className={styles.title}>{strings[language].homePage.title}</div>
      <Link to="/game" className={styles.start}>
        <div>{strings[language].homePage.start}</div>
      </Link>
      <Link to="/settings">
        <FloatingButton
          icon={<FiSettings size={30} className="floating-button-icon" />}
          style={{ top: "10px", right: "10px" }}
        />
      </Link>
    </div>
  );
};

export default HomePage;
